import request from '@/request'

/* 竞猜活动详细 */
export const selectPartyDetails = data => {
  return request({
    url: '/intFtuPartyGuessPriceinfo/selectPartyDetails.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 竞猜报价统计 */
export const quotationStatistics = data => {
  return request({
    url: '/intFtuPartyGuessPriceinfo/quotationStatistics.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 竞猜报价 */
export const quotedPrice = data => {
  return request({
    url: '/intFtuPartyGuessPriceinfo/quotedPrice.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 中奖历史 */
export const prizeHis = data => {
  return request({
    url: '/intFtuPartyGuessPriceinfo/prizeHis.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 我的参与信息 */
export const playerStatistics = data => {
  return request({
    url: '/intFtuPartyGuessPriceinfo/playerStatistics.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 中奖地址 */
export const addAddress = data => {
  return request({
    url: '/intFtuPartyGuessPriceinfo/addAddress.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
/* 报价次数 */
export const selectQuotationTimes = data => {
  return request({
    url: '/intFtuPartyGuessPriceinfo/selectQuotationTimes.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
